<template>
  <!-- 级联选择框 -->
  <div>
    <!-- <el-popover
      placement="bottom-start"
      width="220"
      trigger="click"
      :ref="'popover' + headerIndex"
    >
      <template #reference>
        <div class="search-header hand" v-if="headerItem.type == 'InputSearch'">
          <span class="search-title">{{ headerItem.label }}</span>
          &nbsp;<el-icon style="vertical-align: middle">
            <Search />
          </el-icon>
        </div>
        <div class="search-header hand" v-else>
          <span class="search-title">{{ headerItem.label }}</span>
          &nbsp;<el-icon style="vertical-align: middle">
            <ArrowDown />
          </el-icon>
        </div>
      </template>
      
    </el-popover> -->
    <!-- <el-cascader 
    :options="headerItem.catrgoryOptions" 
    v-model="headerItem[headerItem.prop || 'cascader']"
    :placeholder="headerItem.label+'(全部)'"
    :teleported="false"
    clearable /> -->
    <el-cascader
        id="cascaderCatrgory"
        :options="headerItem.catrgoryOptions"
        ref="cascaderCatrgory"
        :filterable="catrgoryOptions.length > 9 ? true : false"
        :props="props"
        v-model="headerItem[headerItem.prop || 'cascader']"
        :placeholder="headerItem.label+'(全部)'"
        clearable
        :size="size"
        @change="
          handleSearch(headerIndex, {
            name: 'cascader',
            prop: headerItem.prop,
            value: headerItem[headerItem.prop || 'cascader'],
            row: scope,
            catrgoryOptions: headerItem.catrgoryOptions,
            type: 'cascaderAll',
          })
        "
        @visible-change="elCascaderOnClick"
        @expand-change="elCascaderOnClick"
      >
      </el-cascader>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive, toRefs, watch } from "vue";
import { useStore } from "vuex";
import { isNull } from "../../../common/utils";
export default {
  name: "",
  components: {},
  props: {
    headerItem: Object,
    headerIndex: Number,
    key: Number,
    height: Number,
    scope: Object,
    size: {
      type: String,
      default: "default",
    },
  },
  // 定义属性
  setup(props, { emit }) {
    const data = reactive({
      catrgoryOptions: [],
      catrgoryList: [],
    });
     //级联选择器选择数据
     const cascaderCatrgory = ref();
    const handleSearch = (index, option) => {
      // 目的是选择之后将下拉界面收起
      cascaderCatrgory.value.togglePopperVisible();
      let nodesInfo = cascaderCatrgory.value.getCheckedNodes();
      if (nodesInfo && nodesInfo[0]) {
        if (nodesInfo[0].level == 1) {
          //父级
          option.categoryOneId = nodesInfo[0].value;
        }
        if (nodesInfo[0].level == 2) {
          //子级
          option.categoryId = nodesInfo[0].value;
        }
      } else {
        option.categoryOneId = null;
        option.categoryId = null;
        cascaderCatrgory.value.togglePopperVisible();
      }
      emit("searchFnc", option);
      
    };
    const changeCatrgory = (index, option) => {
      console.log("联级搜索：", option);
      emit("searchFnc", option);
    };
    const editformatData = (value) => {
      return value.split("_").filter((item) => {
        item = Number(item) == NaN ? 0 : Number(item);
        console.log(item);
        return item != 0;
      });
    };
    // 点击lable 选择
    const elCascaderOnClick =() => {
      setTimeout(() => {
        document.querySelectorAll(".el-cascader-node__label").forEach((el) => {
          (el).onclick = function () {
            this.previousElementSibling.click();
          };
        });
      }, 100);
    };

    watch(
      () => props.headerItem.selectedData,
      (newVal) => {
        console.log(newVal, 11232312312312321);
        if (newVal != "_" && newVal !== undefined) {
          // console.log(editformatData(newVal).map(Number));
          props.headerItem[props.headerItem.prop || "cascader"] = editformatData(
            newVal
          ).map(Number);
        }
        console.log(props.headerItem[props.headerItem.prop || "cascader"]);
      },
      {
        deep: true,
        immediate: true,
      }
    );
    const store = useStore();
    const refData = toRefs(data);
    return {
      ...refData,
      props: {
        // 是否为多选
        multiple: props.headerItem.multiple,
        checkStrictly: props.headerItem.checkStrictly
          ? props.headerItem.checkStrictly
          : false, //!props.headerItem.multiple,
        expandTrigger: "hover",
        emitPath: props.headerItem.emitPath ? props.headerItem.emitPath : false,
        value: props.headerItem.cascaderValue || "id",
        label: props.headerItem.cascaderLabel || "name",
        children: props.headerItem.cascaderChildren || "childs",
      },
      changeCatrgory,
      handleSearch,
      cascaderCatrgory,
      elCascaderOnClick,
      // formatTree,
    };
  },
};
</script>

<style scoped>
/* .el-cascader-panel /deep/ .el-radio {
  top: 0 !important;
} */
</style>
